import { useState } from "react";
import { MainLayout } from "@/components/layout/MainLayout";
import { LoadingScreen } from "@/components/layout/LoadingScreen";
import { useTeam } from "@/hooks/useTeam";
import { TeamTabs } from "@/components/team/TeamTabs";
import { GerentesTab } from "@/components/team/GerentesTab";
import { MotorizadosTab } from "@/components/team/MotorizadosTab";
import { MotorizadoDetail } from "@/components/team/MotorizadoDetail";
import { SirvientesTab } from "@/components/team/SirvientesTab";

export default function TeamPage() {
  const { deliverers, members, loading, fetchData } = useTeam();
  const [activeTab, setActiveTab] = useState("motorizados");
  const [selectedDeliverer, setSelectedDeliverer] = useState(null);

  if (loading) return <MainLayout><LoadingScreen /></MainLayout>;

  if (selectedDeliverer) {
    return (
      <MainLayout>
        <MotorizadoDetail
          deliverer={selectedDeliverer}
          onBack={() => setSelectedDeliverer(null)}
          onRefresh={fetchData}
        />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="space-y-4" data-testid="team-page">
        <TeamTabs activeTab={activeTab} onTabChange={setActiveTab} />
        {activeTab === "gerentes" && (
          <GerentesTab members={members} onRefresh={fetchData} />
        )}
        {activeTab === "motorizados" && (
          <MotorizadosTab deliverers={deliverers} onRefresh={fetchData} onSelect={setSelectedDeliverer} />
        )}
        {activeTab === "sirvientes" && (
          <SirvientesTab members={members} onRefresh={fetchData} />
        )}
      </div>
    </MainLayout>
  );
}
